import { EditOutlined, MoreOutlined } from "@ant-design/icons";
import { Dropdown, Space, Switch } from "antd";
import TableAntd from "components/elements/Table";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

const NotifyTable = ({
    isLoading = false,
}) => {
    const { t } = useTranslation();

    const columns = useCallback(
        () => {
            return [
                {
                    title: <div className="text-table" style={{ textAlign: "center" }}>{t('common.index')}</div>,
                    dataIndex: "index",
                    key: "index",
                    render: (_, record, idx) => {
                        return <span
                            style={{
                                color: "#42526D",
                                backgroundColor: "#F5F6F7",
                                borderRadius: "50%",
                                display: "inline-flex",
                                justifyContent: "center",
                                alignItems: "center",
                                margin: "auto",
                                padding: "8px",
                                minWidth: "30px",
                                height: "30px",
                            }}
                        >
                            {/* {(pagination.page - 1) * pagination.size + idx + 1} */}
                        </span>
                    },
                    width: 90,
                    align: "center"
                },
                {
                    title: <div className="text-table" style={{ textAlign: "center" }}>{t('notify_setting.group_name')}</div>,
                    dataIndex: "groupName",
                    key: "groupName",
                    width: 200,
                },
                {
                    title: <div className="text-table" style={{ textAlign: "center" }}>{t('branch.header')}</div>,
                    dataIndex: "branch",
                    key: "branch",
                    width: 150,
                },
                {
                    title: <div className="text-table" style={{ textAlign: "center" }}>{t('employee.label.department')}</div>,
                    dataIndex: "department",
                    key: "department",
                    width: 150,
                },
                {
                    title: <div className="text-table" style={{ textAlign: "center" }}>{t('notify_setting.summary_attendance')}</div>,
                    dataIndex: "summaryAttendance",
                    key: "summaryAttendance",
                },
                {
                    title: <div className="text-table" style={{ textAlign: "center" }}>{t('notify_setting.realTime_attendance')}</div>,
                    dataIndex: "realTimeAttendance",
                    key: "realTimeAttendance",
                    width: 120,
                },
                {
                    title: <div className="text-table" style={{ textAlign: "center" }}>{t('request_all.request_type')}</div>,
                    dataIndex: "requestType",
                    key: "requestType",
                },
                {
                    title: <div className="text-table" style={{ textAlign: "center" }}>{t('employee.label.last_modified')}</div>,
                    dataIndex: "lastModified",
                    key: "lastModified",
                },
                {
                    title: (
                        <div className="text-table" style={{ textAlign: "center" }}>{t("status.entity")}</div>
                    ),
                    dataIndex: "statusFlag",
                    key: "statusFlag",
                    align: "center",
                    width: 120,
                    render: (text, record) => (
                        <Switch
                        // checked={text === "ACTIVE"}
                        // onChange={(checked) => onStatus(checked, record)}
                        />
                    ),
                },
                {
                    title: "",
                    key: "action",
                    align: "center",
                    width: "80px",
                    render: (_, record) => (
                        <Space size="middle">
                            <Dropdown
                                menu={{
                                    items: [
                                        {
                                            key: "1",
                                            // onClick: () => onEdit(record),
                                            label: `${t("action.edit")}`,
                                            icon: (
                                                <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                                            ),
                                        }
                                    ],
                                }}
                            >
                                <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
                            </Dropdown>
                        </Space>
                    ),
                }
            ]
        }, []
    )

    return (
        <TableAntd
            loading={isLoading}
            columns={columns()}
        // dataSource={dataSource}
        />
    )
}

export default NotifyTable;